import React, { Component } from "react";
import { FormControl, FormGroup } from "@mui/material";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import Cookies from "js-cookie";
import Typography from "@mui/material/Typography";
import axios from "axios";
import settings from "../helpers/Settings";
import * as moment from "moment";
import { CSVLink } from "react-csv";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import VisitRegisteration from "./VisitRegisteration";
import { countries } from 'countries-list';
import MoreOptions from "./moreOptions";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
let { KayanURL } = settings;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};
const allTPA = {
  7001463160: "GlobeMed Saudi",
  7001580856: "Nextcare",
  7001604342: "Mednet",
  7001599658: "Totalcare"
}
class PatientRegistration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patient: this.props.iqamaValueFromSearch
        ? { identifier: this.props.iqamaValueFromSearch }
        : {},
      identifier: this.props.iqamaValueFromSearch
        ? this.props.iqamaValueFromSearch
        : "",
      msgFordigitIqama: "",
      registerForm: this.props.registerformfrom === "view" ? false : true,
    };
  }

  componentDidMount = async () => {
    this.getAllPatients();
    this.getAllDoctors();
    // this.getAllDepartments();
    if (this.props.registerformfrom === "view") {
      this.getPatientInfoselected();
      this.getAllVisitsByPatientID();
      this.setState({ visitFlag: true });
    }
  };
  getAllPatients = async () => {
    let Allpatients = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getPatients",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Allpatients) {
      let { data } = Allpatients;
      if (data) {
        if (data.success) {
          this.setState({ success: true, allPatients: data.patients });
        } else {
          this.setState({
            success: false,
            error: data.error,
            allPatients: data.patients,
          });
        }
      }
    }
  };

  handleCloseVisitModal = () => {
    this.setState({ visitModal: false });
    this.getAllVisitsByPatientID();
  };
  HandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "identifier") {
      if (e.target.value == "") {
        this.setState({ msgFordigitIqama: "" });
      } else if (value.length > 10 || value.length < 10) {
        this.setState({ msgFordigitIqama: "Patient Identifier must be 10 digits" });
      } else {
        this.setState({
          patient: { ...this.state.patient, [name]: value },
          [name]: value,
          msgFordigitIqama: "",
        });
      }
    } else {
      this.setState({
        patient: { ...this.state.patient, [name]: value },
        [name]: value,
      });
    }
  };
  HandleDateChange = (e) => {
    let date = moment(e.value.$d).format("YYYY-MM-DD");
    this.setState({ [e.name]: date });
  };
  handleRegistration = async (e) => {
    e.preventDefault();
    this.setState({ requestSent: true, response: false });
    let { allPatients, insuranceInfo, patient } = this.state;
    let flag;
    let iqamaFound = false;
    if (allPatients && allPatients.length > 0) {
      for (let i = 0; i < allPatients.length; i++) {
        if (allPatients[i].identifier === this.state.identifier) {
          iqamaFound = true;
          break;
        }
      }
    }

    if (iqamaFound) {
      this.setState({
        iqamaFoundMessage: "The entered Patient Identifier already registered!",
        requestSent: false,
        response: true,
      });
    } else {
      this.setState({ iqamaFoundMessage: "" })
      if (this.state.msgFordigitIqama == "") {
        if (!patient.identifier || !patient.firstName || !patient.birthDate || !patient.lastName
          || !patient.identifiersType || !patient.nationality || !patient.phone || !patient.gender) {
          let missingFields = [];
          if (!patient.identifier) missingFields.push('Identifier');
          if (!patient.firstName) missingFields.push('First Name');
          if (!patient.lastName) missingFields.push('Last Name');
          if (!patient.birthDate) missingFields.push('Birth Date');
          if (!patient.identifiersType) missingFields.push('Identifier Type');
          if (!patient.nationality) missingFields.push('Nationality');
          if (!patient.phone) missingFields.push('Phone');
          if (!patient.gender) missingFields.push('Gender');

          if (missingFields.length > 0) {
            const errorMessage = `${missingFields.join(', ')} ${missingFields.length > 1 ? 'are' : 'is'} required!`;
            this.setState({ RegistrationError: errorMessage, requestSent: false, response: true });

          }
        } else {
          this.setState({ RegistrationError: "" })
          let addNewPatientResult = await axios.post(
            KayanURL + "api/KSA/RCM/patient/addNewPatient",
            {
              patient: this.state.patient,
              apiToken: Cookies.get("RCM_KSA_Employee_Token"),
            }
          );
          if (addNewPatientResult) {
            this.setState({
              requestSent: false,
              response: true,
              iqamaFoundMessage: "",
            });
            let { data } = addNewPatientResult;
            if (data) {
              if (data.success) {
                this.setState({
                  rejestrationSuccess: true,
                  visitFlag: true,
                  registratiomMsg: "Patient Added Successfully",
                  registerForm: false,
                });
                this.getPatientInfoselected();
                this.getAllVisitsByPatientID();
              } else {
                this.setState({ rejestrationSuccess: false });

              }
            }
          }
        }

      }
    }
  };

  showTOB = async (items, headers) => {
    console.log("items", items);
    console.log("headers", headers);

    let rowsTOB = items.map((item, index) => {
      return (
        <TableRow key={index}>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["benefitType"]}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["allowedMoney"]}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["category"]}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["description"]}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["name"]}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["network"]}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["term"]}
          </TableCell>

          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["unit"]}
          </TableCell>
        </TableRow>
      );
    });
    this.setState({ showTOBModal: true, items, headers, rowsTOB });
  };
  handleCloseTOBModal = () => {
    this.setState({ showTOBModal: false });
  };

  showCoverage = async (coverage) => {
    if (coverage && coverage.length > 0) {
      this.setState({
        showCoverageInfo: true,
        memberid: coverage[0].memberid,
        network: coverage[0].network,
        coverageType: coverage[0]["coverage-type"],
        term: coverage[0].period.start + " to " + coverage[0].period.end,
        subscriberRelationship: coverage[0]["subscriber-relationship"],
        costToBeneficiaryTypesValues: coverage[0].paymentDetails,
      });
      let classRows;
      if (coverage[0].class && coverage[0].class.length > 0) {
        classRows = coverage[0].class.map((element, index) => {
          return (
            <TableRow key={index}>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.type}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.name}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.value}
              </TableCell>
            </TableRow>
          );
        });
        this.setState({ classRows });
      }
    }
  };
  handleCloseCoverageInfoModal = () => {
    this.setState({ showCoverageInfo: false });
  };

  getAllDoctors = async () => {
    let doctors = await axios.put(
      KayanURL + "api/KSA/RCM/employee/getAllDoctors",
      {
        role: "doctor",
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (doctors) {
      let { data } = doctors;
      if (data) {
        if (data.success) {
          this.setState({ success: true, AllDoctors: data.doctors });
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }
  };
  getAllVisitsByPatientID = async () => {
    let iqamaSearch;
    if (this.props.iqamaValueFromSearch) {
      iqamaSearch = this.props.iqamaValueFromSearch;
    } else {
      iqamaSearch = this.state.patient.identifier;
    }
    let Allpatients = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getPatients",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Allpatients) {
      let { data } = Allpatients;
      if (data) {
        if (data.success) {
          this.setState({ success: true, allPatients: data.patients });
        } else {
          this.setState({
            success: false,
            error: data.error,
            allPatients: data.patients,
          });
        }
      }

      let selectedPatient;
      if (data.patients && data.patients.length > 0) {
        selectedPatient = data.patients.filter((p) => {
          return p.identifier == iqamaSearch;
        });
      }

      if (selectedPatient && selectedPatient.length > 0) {
        this.setState({ patientIDselected: selectedPatient[0].id });
        let result = await axios.put(
          KayanURL + "api/KSA/RCM/patient/getAllVisitsByPatientID",
          {
            id: selectedPatient[0].id,
            apiToken: Cookies.get("RCM_KSA_Employee_Token"),
          }
        );
        if (result) {
          let { data } = result;
          if (data) {
            if (data.success) {
              console.log(data.visits, "vvvvvvvvv")
              this.setState({ success: true, allVisits: data.visits });
            } else {
              this.setState({
                success: false,
                error: data.error,
                allVisits: data.visits,
              });
            }
          }
        }
      }
    }
  };
  getPatientInfoselected = async () => {
    let iqamaSearch;
    if (this.props.iqamaValueFromSearch) {
      iqamaSearch = this.props.iqamaValueFromSearch;
    } else {
      iqamaSearch = this.state.patient.identifier;
    }
    let Allpatients = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getPatients",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Allpatients) {
      let { data } = Allpatients;
      if (data) {
        if (data.success) {
          this.setState({ success: true, allPatients: data.patients });
        } else {
          this.setState({
            success: false,
            error: data.error,
            allPatients: data.patients,
          });
        }
      }

      let selectedPatient;
      if (data.patients && data.patients.length > 0) {
        selectedPatient = data.patients.filter((p) => {
          return p.identifier == iqamaSearch;
        });
      }

      if (selectedPatient && selectedPatient.length > 0) {
        console.log(selectedPatient, 'fffffffffffff')
        let patientRows = selectedPatient.map((element, index) => {
          const year = new Date().getFullYear();
          const dateSplit = element.birthdate.split("-");
          const birthYear = dateSplit[0];
          const age = year - birthYear;
          return (
            <TableRow key={index}>
              {/* <TableCell align="center" style={{ fontSize: "small" }}>
                {element.id}
              </TableCell> */}
              <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                {element.firstname + " " + element.lastname}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.identifier}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                {element.identifiertype}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                {element.gender}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.birthdate}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {age}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.medicalfilenumber}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.phone ? element.phone : ""}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.createdat}
              </TableCell>
            </TableRow>
          );
        });
        this.setState({ patientRows });
      }
    }
  };
  handleCheckBox = async (e, index) => {
    let { insuranceInfo, insurance } = this.state;
    if (e.target.checked) {
      insuranceInfo.push(insurance[index]);
      this.setState({ insuranceMsg: "" });
    } else {
      let i = insuranceInfo.indexOf(insurance[index]);
      insuranceInfo.splice(i, 1);
    }
  };
  handleDeleteVisit = async (index) => {
    let result = await axios.put(
      KayanURL + "api/KSA/RCM/patient/deleteVisitById",
      {
        id: index,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (result) {
      let { data } = result;
      if (data) {
        if (data.success) {
          this.setState({ success: true });
          this.getAllVisitsByPatientID();
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }
  };
  handleVisitModalClose = () => {
    this.setState({ visitInfoModalOpen: false });
  };
  handleViewVisit = async (index) => {
    let { allVisits, AllDoctors } = this.state;
    let selectedVisit = allVisits.filter((p) => {
      return p.id == index;
    });
    if (selectedVisit && selectedVisit.length > 0) {
      this.setState({ selectedVisit });
      selectedVisit = selectedVisit[0];
      let selectedDoctor = AllDoctors.filter((p) => {
        return p.id == selectedVisit.doctorid;
      });
      if (selectedDoctor && selectedDoctor.length > 0) {
        let doctorNamevalue = selectedDoctor[0].name;
        this.setState({ doctorNamevalue });
      }
      if (selectedVisit.payment === "insurance") {
        this.setState({ checkEligibilityInfo: true });
        let itemHeader = [
          { label: "Benefit Type", key: "benefitType" },
          { label: "Allowed Money", key: "allowedMoney" },
          { label: "Category", key: "category" },
          { label: "Description", key: "description" },
          { label: "Name", key: "name" },
          { label: "Network", key: "network" },
          { label: "Term", key: "term" },
          { label: "Unit", key: "unit" },
        ];
        let TableOfBenefitsForView = [];
        let arr = [];
        let itemsOfInsurance;
        if (
          selectedVisit.selectedinsurance &&
          selectedVisit.selectedinsurance.length > 0
        ) {
          TableOfBenefitsForView = selectedVisit.selectedinsurance.map(
            (ins, index) => {
              itemsOfInsurance = ins.items;
              this.setState({ itemsOfInsurance });
              /*  let insItems = [];
              if (itemsOfInsurance && itemsOfInsurance.length > 0) {
                for (let i = 0; i < itemsOfInsurance.length; i++) {
                  insItems.push({
                    benefitType: itemsOfInsurance[i].benefitType,
                    allowedMoney: itemsOfInsurance[i].allowedMoney,
                    category: itemsOfInsurance[i].category,
                    description: itemsOfInsurance[i].description,
                    name: itemsOfInsurance[i].name,
                    network: itemsOfInsurance[i].network,
                    term: itemsOfInsurance[i].term,
                    unit: itemsOfInsurance[i].unit,
                  });
                }
                arr.push(insItems);
              } */

              let id = index + 1;
              let siteEligibility = ins.insuranceSiteEligibility;
              return (
                <TableRow key={index}>
                  <TableCell align="center" style={{ fontSize: "small" }}>
                    {id}
                  </TableCell>
                  <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                    {siteEligibility}
                  </TableCell>
                  <TableCell align="center" style={{ fontSize: "small" }}>
                    {ins.Inforce ? "True" : "False"}
                  </TableCell>
                  <TableCell align="center" style={{ fontSize: "small" }}>
                    <a
                      onClick={(e) => {
                        this.showCoverage(ins["coverage"]);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <VisibilityIcon style={{ color: "#6262e7" }} />
                    </a>
                  </TableCell>
                  {itemsOfInsurance && itemsOfInsurance.length > 0 ? (
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      <CSVLink
                        filename="report.csv"
                        data={itemsOfInsurance}
                        headers={itemHeader}
                      >
                        <FileDownloadIcon />
                      </CSVLink>

                      <a
                        onClick={(e) => {
                          this.showTOB(itemsOfInsurance, itemHeader);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <VisibilityIcon style={{ color: "#6262e7" }} />
                      </a>
                    </TableCell>
                  ) : null}
                </TableRow>
              );
            }
          );
          this.setState({ TableOfBenefitsForView });
        }
      } else {
        this.setState({
          checkEligibilityInfo: false,
          TableOfBenefitsForView: [],
        });
      }
      this.setState({ visitInfoModalOpen: true });
    }
  };
  render() {
    let {
      requestSent,
      response,
      costToBeneficiaryTypesValues,
      error,
      allVisits,
      allPatients,
      AllDoctors,
      allDepartments,
      classRows,
      patientRows,
    } = this.state;
    const allCountries = Object.entries(countries).map(([code, country]) => ({
      code,
      name: country.name,
    }));
    let visitRows, name;
    if (allVisits && allVisits.length > 0) {
      console.log(allVisits)
      visitRows = allVisits.map((element, index) => {
        let deptName, doctorName;
        if (allPatients && allPatients.length > 0) {
          let selectedPatient = allPatients.filter((p) => {
            return p.id == element.patientid;
          });
          if (selectedPatient && selectedPatient.length > 0) {
            name =
              selectedPatient[0].firstname + " " + selectedPatient[0].lastname;
          }
        }

        // if (allDepartments && allDepartments.length > 0) {
        //   let selectedDepartment = allDepartments.filter((p) => {
        //     return p.id == element.departmentid;
        //   });
        //   if (selectedDepartment && selectedDepartment.length > 0) {
        //     deptName = selectedDepartment[0].name;
        //   }
        // }
        if (AllDoctors && AllDoctors.length > 0) {
          let selectedDoctor = AllDoctors.filter((p) => {
            return p.id == element.doctorid;
          });
          console.log(selectedDoctor)
          if (selectedDoctor && selectedDoctor.length > 0) {
            doctorName = selectedDoctor[0].name;
          }
        }
        let visitStatus;
        if (element.visitstatus === "1") {
          visitStatus = "Not Started";
        } else if (element.visitstatus === "2") {
          visitStatus = "Started";
        } else if (element.visitstatus === "3") {
          visitStatus = "Pending";
        } else if (element.visitstatus === "4") {
          visitStatus = "Ended";
        }
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.id}
            </TableCell>
            {/*  <TableCell align="center" style={{ fontSize: "small" }}>
              {element.invoicenumber}
            </TableCell> */}
            {/* <TableCell align="center" style={{ fontSize: "small" }}>
              {deptName}
            </TableCell> */}
            <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
              {doctorName}
            </TableCell>
            {/*  <TableCell align="center" style={{ fontSize: "small" }}>
              {element.payment.charAt(0).toUpperCase() +
                element.payment.slice(1)}
            </TableCell> */}
            <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
              {element.visittype}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.visitdate}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
              {visitStatus}
            </TableCell>
            <TableCell align="center">
              <MoreOptions
                index={element.id}
                handleDelete={() => this.handleDeleteVisit(element.id)}
                handleView={() => this.handleViewVisit(element.id)}
                optionFor="visit"
              />
            </TableCell>
          </TableRow>
        );
      });
    }
    let costRows;
    if (
      costToBeneficiaryTypesValues &&
      costToBeneficiaryTypesValues.length > 0
    ) {
      costRows = costToBeneficiaryTypesValues.map((element, index) => {
        let keyOfElement = Object.keys(element)[0];
        return (
          <Typography
            id="modal-modal-title"
            key={index}
            sx={{ mt: 2 }}
            style={{ textTransform: "capitalize" }}
          >
            {keyOfElement} : {element[[keyOfElement]]}
          </Typography>
        );
      });
    }

    return (
      <>
        <div style={{ width: "90%", margin: "auto", padding: "20px" }}>
          <FormControl style={{ width: "100%" }}>
            <Container>
              {this.state.registerForm ? (
                <>
                  {/*  <h4
                   style={
                      {
                          margin: "50px 0 20px 96px" 
                      }
                    } 
                  >
                    New Patient
                  </h4> */}
                  <Row>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>Patient Identifier *</Form.Label>
                        <Form.Control
                          type="text"
                          name="identifier"
                          onChange={this.HandleInputTextChange}
                          required
                          defaultValue={this.state.identifier}
                          placeholder="Enter Patient Identifier"
                        />
                        {this.state.msgFordigitIqama ? (
                          <span style={{ color: "red", fontSize: "10px" }}>
                            {this.state.msgFordigitIqama}!
                          </span>
                        ) : null}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>First Name *</Form.Label>
                        <Form.Control
                          type="text"
                          name="firstName"
                          required
                          onChange={this.HandleInputTextChange}
                          placeholder="Enter First Name"
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Birthdate *</Form.Label>
                        <Form.Control
                          type="date"
                          name="birthDate"
                          onChange={this.HandleInputTextChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>Identifier Type *</Form.Label>
                        <Form.Select
                          onChange={this.HandleInputTextChange}
                          required
                          name="identifiersType"
                        >
                          <option value="0">select...</option>
                          <option value="iqama">Iqama</option>
                          <option value="passport">Passport</option>
                          <option value="nationalID">National ID</option>
                          <option value="borderNumber">Border Number</option>
                          <option value="displacedNumber">Displaced Number</option>
                        </Form.Select>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Last Name *</Form.Label>
                        <Form.Control
                          type="text"
                          name="lastName"
                          onChange={this.HandleInputTextChange}
                          required
                          placeholder="Enter Last Name"
                        />
                      </Form.Group>


                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Phone </Form.Label>
                        <Form.Control
                          type="text"
                          name="phone"
                          required
                          onChange={this.HandleInputTextChange}
                          placeholder="Enter Phone"
                        />
                      </Form.Group>

                    </Col>
                    <Col>

                      <Form.Group className="mb-3">
                        <Form.Label>Nationality *</Form.Label>
                        <Form.Select
                          onChange={this.HandleInputTextChange}
                          required
                          name="nationality"
                        >
                          <option value="" >Select a nationality</option>
                          {allCountries.map((nation) => (
                            <option key={nation.code} value={nation.code}>
                              {nation.name} ({nation.code})
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Gender *</Form.Label>
                        <Form.Select
                          onChange={this.HandleInputTextChange}
                          required
                          name="gender"
                        >
                          <option value="0">select...</option>
                          <option value="female">Female</option>
                          <option value="male">Male</option>
                        </Form.Select>
                      </Form.Group>
                      <Button
                        variant="primary"
                        type="submit"
                        onClick={(e) => this.handleRegistration(e)}
                        style={{
                          width: "100%",
                          marginTop: "32px",
                          backgroundColor: "rgb(97 110 120",
                          border: "1px solid rgb(97 110 120",
                        }}
                      >
                        Register
                      </Button>
                    </Col>
                  </Row>
                  {this.state.RegistrationError ? (<>
                    <Stack style={{ margin: "20px", textTransform: "capitalize", width: "fit-content" }}>
                      <Alert severity="error">
                        {this.state.RegistrationError}
                      </Alert>
                    </Stack>
                  </>) : null}
                  <div
                    style={{
                      width: "50%",
                      marginright: "auto",
                      textAlign: "left",
                    }}
                  >
                    <Button
                      variant="primary"
                      type="submit"
                      onClick={() => this.props.backToPatientScreen()}
                      style={{
                        width: "10%",
                        marginTop: "32px",
                        padding: "3px 6px",
                        backgroundColor: "rgb(97 110 120",
                        border: "1px solid rgb(97 110 120",
                      }}
                    >
                      <ArrowBackIcon />
                    </Button>
                  </div>
                  {requestSent && !response ? (
                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                      <Spinner animation="border" variant="success" />
                    </div>
                  ) : this.state.rejestrationSuccess ? (
                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                      <h5 style={{ color: "green", fontSize: "small" }}>
                        {this.state.registratiomMsg}
                      </h5>
                    </div>
                  ) : response && error ? (
                    <h5 style={{ color: "red" }}>{error}</h5>
                  ) : null}
                </>
              ) : patientRows && patientRows.length > 0 ? (
                <>
                  <TableContainer
                    component={Paper}
                    style={{ marginTop: "20px" }}
                  >
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead style={{ backgroundColor: "#fafafa" }}>
                        <TableRow style={{ textAlign: "center" }}>
                          {/* <TableCell align="center">ID</TableCell> */}
                          <TableCell align="center">Name</TableCell>
                          <TableCell align="center">Identifier</TableCell>
                          <TableCell align="center">Patient Identifier</TableCell>
                          <TableCell align="center">Gender</TableCell>
                          <TableCell align="center">Birth Date</TableCell>
                          <TableCell align="center">Age</TableCell>
                          <TableCell align="center">
                            Medical File Number
                          </TableCell>
                          <TableCell align="center">Phone</TableCell>
                          <TableCell align="center">Created At</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>{patientRows}</TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : null}
              {this.state.iqamaFoundMessage ? (
                <div style={{ textAlign: "center" }}>
                  <h5 style={{ color: "red" }}>
                    {this.state.iqamaFoundMessage}
                  </h5>
                </div>
              ) : null}
              {this.state.visitFlag ? (
                <>
                  {this.state.allVisits && this.state.allVisits.length > 0 ? (
                    <>
                      <hr />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "20px",
                        }}
                      >
                        <Button
                          variant="primary"
                          type="submit"
                          onClick={() =>
                            this.setState({
                              visitModal: true,
                            })
                          }
                          style={{
                            width: "20%",
                            backgroundColor: "rgb(97 110 120",
                            border: "1px solid rgb(97 110 120",
                          }}
                        >
                          Add Appointment
                        </Button>
                      </div>
                      <TableContainer
                        component={Paper}
                        style={{ marginTop: "20px" }}
                      >
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">Visit Number</TableCell>
                              {/*   <TableCell align="center">
                                Invoice Number
                              </TableCell> */}
                              {/* <TableCell align="center">Department</TableCell> */}
                              <TableCell align="center">Doctor</TableCell>
                              {/*  <TableCell align="center">Payment</TableCell> */}
                              <TableCell align="center">Visit Type</TableCell>
                              <TableCell align="center">Visit Date</TableCell>
                              <TableCell align="center">Visit Status</TableCell>
                              <TableCell align="center">Actions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>{visitRows}</TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : (
                    <h5
                      style={{
                        marginTop: "30px",
                        textAlign: "left",
                        fontSize: "small",
                      }}
                    >
                      There are no visits for the patient{" "}
                      <span>
                        <a
                          style={{
                            textDecoration: "underline",
                            color: "grey",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            this.setState({
                              visitModal: true,
                            })
                          }
                        >
                          Add Appointment
                        </a>
                      </span>
                    </h5>
                  )}
                </>
              ) : null}
              {this.state.visitModal ? (
                <>
                  <Modal
                    open={this.state.visitModal}
                    onClose={this.handleCloseVisitModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box
                      sx={style}
                      style={{
                        width: "60%",
                        height: "350px",
                        overflowY: "scroll",
                      }}
                    >
                      <VisitRegisteration
                        AllDepartments={this.state.allDepartments}
                        backToRegistrationScreen={this.handleCloseVisitModal}
                        patientIDselected={this.state.patientIDselected}
                      />
                    </Box>
                  </Modal>
                </>
              ) : null}
              {this.state.visitFlag ? (
                <div
                  style={{
                    width: "50%",
                    marginright: "auto",
                    textAlign: "left",
                  }}
                >
                  <Button
                    variant="primary"
                    type="submit"
                    onClick={() => {
                      this.setState({
                        patientRows: [],
                        visitFlag: false,
                      });
                      this.props.backToPatientScreen();
                    }}
                    style={{
                      width: "10%",
                      marginTop: "32px",
                      padding: "3px 6px",
                      backgroundColor: "rgb(97 110 120",
                      border: "1px solid rgb(97 110 120",
                    }}
                  >
                    <ArrowBackIcon />
                  </Button>
                </div>
              ) : null}
            </Container>
          </FormControl>
          <div>
            {this.state.selectedVisit && this.state.selectedVisit.length > 0 ? (
              <>
                <Modal
                  open={this.state.visitInfoModalOpen}
                  onClose={this.handleVisitModalClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box
                    sx={style}
                    style={{
                      width: this.state.checkEligibilityInfo ? "70%" : "30%",
                      height: this.state.checkEligibilityInfo
                        ? "550px"
                        : "380px",
                      overflowY: "scroll",
                    }}
                  >
                    {/*    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                      style={{ textAlign: "center" }}
                    >
                      Visit Information
                    </Typography> */}

                    <div
                      style={{
                        width: "80%",
                        /*   backgroundColor: "#a59f9f", */
                        margin: "auto",
                        /*   marginTop: "10px", */
                        /*   padding: "15px",
                        paddingBottom: "10px",
                        borderRadius: "24px", */
                        /*   width: this.state.checkEligibilityInfo ? "70%" : "100%", */
                      }}
                    >
                      <Row>
                        <Col style={{ padding: "20px" }}>
                          <Typography
                            id="modal-modal-description"
                            sx={{ mt: 2 }}
                            style={{ textTransform: "capitalize" }}
                          >
                            Visit Type: {this.state.selectedVisit[0].visittype}
                          </Typography>
                          <Typography
                            id="modal-modal-description"
                            sx={{ mt: 2 }}
                            style={{ textTransform: "capitalize" }}
                          >
                            Visit Date: {this.state.selectedVisit[0].visitdate}
                          </Typography>
                          <Typography
                            id="modal-modal-description"
                            sx={{ mt: 2 }}
                            style={{ textTransform: "capitalize" }}
                          >
                            Doctor: {this.state.doctorNamevalue}
                          </Typography>
                          <Typography
                            id="modal-modal-description"
                            sx={{ mt: 2 }}
                            style={{ textTransform: "capitalize" }}
                          >
                            Payment: {this.state.selectedVisit[0].payment}
                          </Typography>
                        </Col>
                        {this.state.checkEligibilityInfo ? (
                          <Col style={{ padding: "20px" }}>
                            <Typography
                              id="modal-modal-description"
                              sx={{ mt: 2 }}
                              style={{ textTransform: "capitalize" }}
                            >
                              Site Eligibility:{" "}
                              {this.state.selectedVisit[0].siteeligibility}
                            </Typography>
                            {/*  <Typography
                              id="modal-modal-description"
                              sx={{ mt: 2 }}
                            >
                              Service Start:{" "}
                              {this.state.selectedVisit[0].servicestart}
                            </Typography>
                            <Typography
                              id="modal-modal-description"
                              sx={{ mt: 2 }}
                            >
                              Service End:{" "}
                              {this.state.selectedVisit[0].serviceend}
                            </Typography> */}
                            {this.state.selectedVisit[0].tpa ? (
                              <Typography
                                id="modal-modal-description"
                                sx={{ mt: 2 }}
                              >
                                TPA:{" "}
                                {allTPA[this.state.selectedVisit[0].tpa]}
                              </Typography>
                            ) : null}
                            {this.state.selectedVisit[0].insurancecompany ? (
                              <Typography
                                id="modal-modal-description"
                                sx={{ mt: 2 }}
                              >
                                Insurance:{" "}
                                {this.state.selectedVisit[0].insurancecompany}
                              </Typography>
                            ) : null}



                          </Col>
                        ) : null}
                      </Row>
                    </div>

                    {this.state.TableOfBenefitsForView &&
                      this.state.TableOfBenefitsForView.length > 0 ? (
                      <>
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                          sx={{ mt: 2 }}
                          style={{ textAlign: "center" }}
                        >
                          Plan/Policy
                        </Typography>
                        <TableContainer
                          component={Paper}
                          style={{ marginTop: "20px" }}
                        >
                          <Table
                            sx={{ minWidth: 650 }}
                            aria-label="simple table"
                          >
                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                              <TableRow style={{ textAlign: "center" }}>
                                <TableCell align="center">ID</TableCell>
                                <TableCell align="center">
                                  Site Eligibility
                                </TableCell>
                                <TableCell align="center">Inforce</TableCell>

                                <TableCell align="center">Coverage</TableCell>
                                {this.state.itemsOfInsurance &&
                                  this.state.itemsOfInsurance.length > 0 ? (
                                  <TableCell align="center">TOB</TableCell>
                                ) : null}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.TableOfBenefitsForView}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    ) : null}
                  </Box>
                </Modal>
              </>
            ) : null}
            {this.state.showCoverageInfo ? (
              <>
                <Modal
                  open={this.state.showCoverageInfo}
                  onClose={this.handleCloseCoverageInfoModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box
                    sx={style}
                    style={{
                      width: "70%",
                      height: "500px",
                      overflowY: "scroll",
                    }}
                  >
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                      style={{ textAlign: "center" }}
                    >
                      Coverage Information
                    </Typography>
                    <Typography id="modal-modal-title" sx={{ mt: 2 }}>
                      Member ID:{this.state.memberid}
                    </Typography>
                    <Typography
                      id="modal-modal-title"
                      sx={{ mt: 2 }}
                      style={{ textTransform: "capitalize" }}
                    >
                      Coverage Type:{this.state.coverageType}
                    </Typography>
                    <Typography
                      id="modal-modal-title"
                      sx={{ mt: 2 }}
                      style={{ textTransform: "capitalize" }}
                    >
                      Network:{this.state.network}
                    </Typography>
                    <Typography
                      id="modal-modal-title"
                      sx={{ mt: 2 }}
                      style={{ textTransform: "capitalize" }}
                    >
                      Term:{this.state.term}
                    </Typography>
                    <Typography
                      id="modal-modal-title"
                      sx={{ mt: 2 }}
                      style={{ textTransform: "capitalize" }}
                    >
                      subscriber Relationship:
                      {this.state.subscriberRelationship}
                    </Typography>
                    {this.state.costToBeneficiaryTypesValues &&
                      this.state.costToBeneficiaryTypesValues.length > 0 ? (
                      <>{costRows}</>
                    ) : null}
                    <Typography
                      id="modal-modal-title"
                      sx={{ mt: 2 }}
                      style={{
                        textTransform: "capitalize",
                        textAlign: "center",
                      }}
                    >
                      Classes
                    </Typography>
                    <TableContainer
                      component={Paper}
                      style={{ marginTop: "20px" }}
                    >
                      <Table sx={{ minWidth: 100 }} aria-label="simple table">
                        <TableHead style={{ backgroundColor: "#fafafa" }}>
                          <TableRow style={{ textAlign: "center" }}>
                            <TableCell align="center">Type</TableCell>
                            <TableCell align="center">Name</TableCell>
                            <TableCell align="center">Value</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>{classRows}</TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Modal>
              </>
            ) : null}
          </div>

          {this.state.showTOBModal ? (
            <>
              <Modal
                open={this.state.showTOBModal}
                onClose={this.handleCloseTOBModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box
                  sx={style}
                  style={{
                    width: "70%",
                    height: "70%",
                    overflowY: "scroll",
                  }}
                >
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    style={{ textAlign: "center" }}
                  >
                    TOB
                  </Typography>

                  {
                    <TableContainer
                      component={Paper}
                      style={{ marginTop: "20px" }}
                    >
                      <Table sx={{ minWidth: 100 }} aria-label="simple table">
                        <TableHead style={{ backgroundColor: "#fafafa" }}>
                          <TableRow style={{ textAlign: "center" }}>
                            {this.state.headers.map((head) => {
                              console.log("head", head);
                              return (
                                <TableCell align="center">
                                  {head.label}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        </TableHead>
                        <TableBody>{this.state.rowsTOB}</TableBody>
                      </Table>
                    </TableContainer>
                  }
                </Box>
              </Modal>
            </>
          ) : null}
        </div>
      </>
    );
  }
}

export default PatientRegistration;
